import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAoName, FormItemAoNo} from '../AO/FormChooseAo.jsx'
import Model from './ModelAd.mjs'

export const FormItemAdTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="adTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseAd(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemAoNo />
            <FormItemAoName />
            <FormItemAdTitle />
        </FormChooseDesign>
    )
}
